import React, { Fragment, useState } from 'react'
import { withRouter } from 'react-router-dom'
import { v4 as uuidv4 } from 'uuid'
import { DataGrid, GridToolbarQuickFilter } from '@mui/x-data-grid'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import { ThemeProvider, createTheme } from '@mui/material/styles'
import { obtenerSolicitudesFC01RevicionNacionalAdmin, obtenerSolicitudesFC01RevisionNacionalAuxiliar } from '../../../../redux/DuckOrganismoCertificacion/EstatusSolicitudesUIF01Duck'
import { useDispatch, useSelector } from 'react-redux'
import moment from 'moment'
//import ModalAsignarReasignarComponent from './ModalAsignarReasignarComponent'
import { actualizarFC01_OCAccion } from '../../../../redux/DuckOrganismoCertificacion/SolicitudesFC01_OCDuck'
import { ObtenerInformacionCliente } from '../../../../redux/DuckOrganismoCertificacion/SolicitudesFC01_OCDuck'

function SolicitudesRevisionOCExportacionComponent(props) {

    const dispatch = useDispatch()
    const fechaHoy = moment().format('YYYY-MM-DD')
    const solicitudes = useSelector(store => store.EstatusSolicitudesUIF01.solicitudesRevicionOC)
    const dataUser = useSelector(store => store.Usuario.user)

    /*React.useEffect(async () => {
        if (dataUser[0]?.idrol == 1) await dispatch(obtenerSolicitudesFC01RevicionNacionalAdmin(1))
        if (dataUser[0]?.idrol == 7) await dispatch(obtenerSolicitudesFC01RevisionNacionalAuxiliar(dataUser?.[0].usuario))
    }, [])*/


    const columns = [

        { field: 'tipoSolicitud', headerAlign: 'center', headerName: 'Tipo de servicio', width: 250, },
        { field: 'folio', headerAlign: 'center', headerName: 'Folio', width: 130 },
        { field: 'numerosocio', headerAlign: 'center', headerName: 'No. de socio', width: 120 },
        { field: 'nombrerazonsocial', headerAlign: 'center', headerName: 'Razón social', width: 320 },
        { field: 'revisor', headerAlign: 'center', headerName: 'Revisor', width: 200 },
        {
            field: 'accion', headerAlign: 'center', headerName: 'Acción', width: 250,
            renderCell: (params) =>
                <div className='row'>
                    <ThemeProvider theme={theme}>
                        {dataUser[0]?.idrol == 1 && params?.row?.revisor != null && params?.row?.revisor != undefined && params?.row?.revisor != '' &&
                            <div className="col-6">
                                <Button variant="contained" color="secondary" style={{ width: '100%' }} onClick={() => Asignacion(params)}>Reasignar</Button>
                            </div>
                        }
                        {dataUser[0]?.idrol == 1 && (params?.row?.revisor == null || params?.row?.revisor == undefined || params?.row?.revisor == '') &&
                            <div className="col-6">
                                <Button variant="contained" color="secondary" style={{ width: '100%' }} onClick={() => Asignacion(params)}>Asignar</Button>
                            </div>
                        }
                        {dataUser[0]?.idrol == 1 && params?.row?.revisor != null && params?.row?.revisor != undefined && params?.row?.data?.revisor != '' &&
                            <div className="col-6">
                                <Button variant="contained" color="primary" style={{ width: '100%' }} onClick={() => Revisar(params)}>Revisar</Button>
                            </div>
                        }
                        {dataUser[0]?.idrol == 7 && params?.row?.revisor != null && params?.row?.revisor != undefined && params?.row?.data?.revisor != '' &&
                            <div className="col-12">
                                <Button variant="contained" color="primary" style={{ width: '60%' }} onClick={() => Revisar(params)}>Revisar</Button>
                            </div>
                        }
                    </ThemeProvider>
                </div>
        }
    ]

    const rows = []
    /*solicitudes?.map(solicitud => {
        let revisor = ''
        rows.push({
            id: uuidv4(), idfc01_solicitudregistro: solicitud?.solicitudesuifc01?.fc_01_solicitudderegistro?.idfc01_solicitudregistro,
            numerosocio: solicitud?.solicitudesuifc01?.fc_01_solicitudderegistro?.numerosocio,
            tipoSolicitud: 'Solicitud de inscripción',
            nombrerazonsocial: solicitud?.solicitudesuifc01?.fc_01_solicitudderegistro?.nombrerazonsocial,
            idlogin: solicitud?.solicitudesuifc01?.fc_01_solicitudderegistro?.idlogin, idsolicitudesuifc01: solicitud?.solicitudesuifc01?.idsolicitudesuifc01,
            data: solicitud, folio: solicitud?.solicitudesuifc01?.fc_01_solicitudderegistro?.folio, revisor: solicitud?.revisor,
            idsolicitudesocfc01: solicitud?.idsolicitudesocfc01

        })
    })*/

    const theme = createTheme({
        palette: {
            primary: {
                main: "#7D9A47"
            },
            secondary: {
                main: "#DC3545"
            }
        },
        typography: {
            fontFamily: "Montserrat",
            textTransform: 'none',
            button: {
                fontSize: 16,
                fontWeight: 500,
                fontFamily: "Montserrat",
                textTransform: 'none'
            }
        }
    });

    function QuickSearchToolbar() {
        return (
            <Box
                sx={{
                    p: 0.5,
                    pb: 0,
                    mb: 2,
                    textAlign: 'left',
                    height: 30,
                    width: '100%',
                    backgroundColor: 'white'
                }}>
                <ThemeProvider theme={theme}>
                    <GridToolbarQuickFilter style={{ backgroundColor: '#F4F6F6', width: '100%', fontFamily: 'Montserrat' }} placeholder='Búsqueda...' />
                </ThemeProvider>
            </Box>
        );
    }

    const [openModal, setOpenModal] = React.useState(false);
    const [row, setRow] = React.useState(false);

    const Asignacion = async (params) => {
        let dataAsignacion = { ocsolicitudfc01: params?.row?.data?.solicitudesuifc01?.ocsolicitudfc01, idsolicitudesuifc01: params?.row?.idsolicitudesuifc01 }
        setOpenModal(true)
        setRow({ data: dataAsignacion })
        if (dataUser[0]?.idrol == 1) await dispatch(obtenerSolicitudesFC01RevicionNacionalAdmin(1))
        if (dataUser[0]?.idrol == 7) await dispatch(obtenerSolicitudesFC01RevisionNacionalAuxiliar(dataUser?.[0].usuario))
    }

    const Revisar = async (params) => {

        let fechaatendida = new Date(fechaHoy).toISOString()
        let data = {
            idestatusoc: 1, fechaatendida: fechaatendida,
            idsolicitudesocfc01: params?.row?.idsolicitudesocfc01
        }
        await dispatch(actualizarFC01_OCAccion(data))
        await dispatch(ObtenerInformacionCliente(params.row.idsolicitudesuifc01))
        props.history.push('/InformacionClienteComponent')
    }

    return (
        <Fragment>
            <div className='container'>
                <h3 className='text-center mt-5 pt-3' style={{ fontWeight: 'bolder', fontFamily: 'Montserrat' }}>SOLICITUDES EN REVISIÓN OC</h3><br />
                <div style={{ height: 600, width: '100%', color: 'black', paddingTop: 0 }}>
                    <DataGrid
                        rows={rows}
                        columns={columns}
                        pageSize={10}
                        components={{ Toolbar: QuickSearchToolbar }}
                        getRowHeight={() => 'auto'}
                        sx={{
                            boxShadow: 0,
                            color: 'black',
                            border: 0,
                            fontFamily: 'Montserrat',
                            '& .MuiDataGrid-cell': {
                                display: 'block',
                                position: 'relative',
                                textAlign: 'center',
                                paddingTop: '10px',
                                paddingBottom: '15px'
                            },
                            '& .MuiDataGrid-columnHeaders': {
                                backgroundColor: '#0C365A',
                                color: 'white',
                                fontFamily: 'Montserrat',
                                fontWeight: 'bold',
                                height: '20px'
                            }
                        }}
                    />
                </div>
            </div>
            {/*openModal && <ModalAsignarReasignarComponent setOpenModal={setOpenModal} data={row} />*/}
        </Fragment>
    )
}

export default withRouter(SolicitudesRevisionOCExportacionComponent)